import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const printContactDetail = {
	header: 'Detail kontaktu',
	owner: 'Vlastník',
	client: 'Klient',
	contactSource: 'Zdroj kontaktu',
	letterSend: 'Odeslání dopisu',
	psEndDate: 'Datum konce smlouvy',
};

export default Object.assign({}, printContactDetail, createLabeledMessages(printContactDetail));
